<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Associazione Questionari
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5" style="overflow-y: auto">
      <v-container>
        <v-row
          align="center"
          justify="center"
          v-if="relazione_sel.id_relazione == -1"
        >
          <v-col cols="12">
            <div style="color: rgb(0, 0, 0); font-size: 18px">
              Seleziona il questionario da associare alle sotto-commesse di
              questo elemento.
            </div>
            <div class="mt-5">
              <!-- Bottone di aggiunta -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="aggiungiQestionario"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Associa</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" v-else>
          <v-col cols="12">
            <div style="color: rgb(0, 0, 0); font-size: 18px">
              Questionario attualmente associato:
              {{ relazione_sel.titolo_questionario }}
            </div>
            <div class="mt-5">
              <!-- Bottone di aggiunta -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="aggiungiQestionario"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Associa</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Dialog del componente dinamico Check -->
    <v-dialog class="ma-0 pa-0" v-model="check_dialog_visible">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            @click_chiudi="closeCheck"
            :component="'check'"
            @loaded="handleCheckLoaded()"
            ref="windowframe_check"
            @questionario_selezionato="handleQuestionarioSelezionato"
            :input_args="input_args"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

class Relazione {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_relazione", default_val: -1 },
      { nome: "id_modulo", default_val: null },
      { nome: "id_riferimento", default_val: null },
      { nome: "modulo", default_val: "questionario" },
      { nome: "pk_modulo", default_val: "id_questionario" },
      { nome: "pk_riferimento", default_val: "id_commessa" },
      { nome: "riferimento", default_val: "commessa" },
      { nome: "titolo_questionario", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "AssociaQuestionariEM",
  components: { SnackbarQV, WindowFrame },
  props: {
    commessa_principale: {
      type: Object,
      default: () => {},
    },
    items_commesse: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: () => [],
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      conferma_check_visible: false,
      input_args: {
        toolbar_visible: false,
        toolbar_btn_autorizzazioni: true,
        toolbar_btn_chiudi: false,
        toolbar_btn_esecuzione: false,
        toolbar_btn_progettazione: true,
        toolbar_btn_risultati: false,
      },
      relazione_sel: new Relazione(),

      // Modal
      check_dialog_visible: false,

      // Array
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          this.getRelazioniModuli();
        }
      },
    },
  },
  methods: {
    aggiungiQestionario() {
      this.check_dialog_visible = true;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    closeCheck() {
      if (this.check_dialog_visible === true) {
        this.check_dialog_visible = false;
      }

      if (this.check_dialog_questionari_visible === true) {
        this.check_dialog_questionari_visible = false;
      }
    },
    
    getRelazioniModuli() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getrelazionimoduli",
          token: localStorage.user_token,
          modulo: "questionario",
          riferimento: "commessa",
          id_personale: localStorage.id,
          id_riferimento: this.commessa_principale.id_commessa,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.result.tabella.length === 0) {
              this.relazione_sel = new Relazione();
            } else {
              this.relazione_sel = new Relazione(res.data.result.tabella[0]);
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    handleCheckLoaded() {
      this.$refs.windowframe_check.postEvent("setparams", {
        landing_page: "dashboard",
      });
    },
    handleQuestionarioSelezionato(arg) {
      const arr_tmp = new Array();

      // Se esisteva già un'associazione, la cancello
      /*if (this.relazione_sel.id_relazione != -1) {
        const relazione_tmp = new Relazione(this.relazione_sel);
        relazione_tmp.validita = 0;
        arr_tmp.push(relazione_tmp);
      }*/

      this.items_commesse.forEach((c) => {
        arr_tmp.push({
          id_relazione: -1,
          id_riferimento: c.id_commessa,
          id_modulo: arg.id_questionario,
          id_padre: this.commessa_principale.id_commessa,
          riferimento: "commessa",
          pk_riferimento: "id_commessa",
          modulo: "questionario",
          pk_modulo: "id_questionario",
          obbligatorio: 1,
          multiplo: 0,
          validita: 1,
        });
      });

      const request = {
        controller: "Global",
        method: "PUT",
        richiesta: {
          action: "updaterelazioni",
          token: localStorage.user_token,
          tabella: arr_tmp,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getRelazioniModuli();
            this.check_dialog_visible = false;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile cancellare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile cancellare i dati."
          );
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>